import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { LocaleProvider } from 'antd';
import { Provider } from 'react-redux';
import reducers from './reducer';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import './index.css';
import zhCN from 'antd/lib/locale-provider/zh_CN';

let store = createStore(reducers, applyMiddleware(thunk));
const { REACT_APP_ENV } = process.env;
if (REACT_APP_ENV === 'dev') {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  store = createStore(reducers, composeEnhancers(
    applyMiddleware(thunk)
  ));
}
toast.configure({
  position: "top-center",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true
})

ReactDOM.render((
  <Provider store={store}>
    <LocaleProvider locale={zhCN}>
      <App />
    </LocaleProvider>
  </Provider>
), document.getElementById('root'));
